import React from 'react';
import './footer.css';
class Footer extends React.Component{
    face(){
        window.open("https://web.facebook.com/jasnel.juilletetienne"); 
    }
    ins(){
        window.open("https://www.instagram.com/jasnel09/"); 
    }
    github(){
        window.open("https://github.com/jasneljuillet"); 
        
    }
    render(){
        return(
            <footer>  
                        <section >
                        <a href="" onClick={this.face}><span className="fa fa-facebook"></span></a>
                           <a href=""  onClick={this.ins}><span className="fa fa-instagram"></span></a> 
                            <a href="" onClick={this.github}><span className="fa fa-github"></span></a>
                            {/* <a href="" ><span className="fa fa-linkedin"></span></a> */}
                            <br></br>
                            </section>
                     Copyrights {new Date().getFullYear()} All Rights Reserved By Jasnel JUILLET
          </footer>
        )
    }
}
export default Footer;
